import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../features';
import {loadStripe} from '@stripe/stripe-js';
import {StripeCardPayment} from './class-card-payment';
import {onCheckoutSubmitManual, tokenizedMethodSelected, unblockCheckout} from '../checkout';
import {insertTokenFields} from './stripe';
import {type AbstractStripePayment} from './abstract/class-abstract-stripe-payment';
import {$qs} from '../../../@shared/ts/dom';

async function initAddPaymentMethodPage($addPaymentMethodForm: HTMLFormElement) {
	if (!Feature.enabled(FeatureFlag.STRIPE_GATEWAYS) || !Feature.enabled(FeatureFlag.STRIPE_CARD_GATEWAY)) {
		return;
	}

	const publicKey = Feature.metadata<string>(FeatureFlag.STRIPE_GATEWAYS, 'public_key');
	const connectId = Feature.metadata<string>(FeatureFlag.STRIPE_GATEWAYS, 'connect_id');

	if (!publicKey || !connectId) {
		return;
	}

	const stripe = await loadStripe(publicKey, {stripeAccount: connectId, locale: 'auto'});
	if (!stripe) {
		return;
	}

	const elements = stripe.elements();
	const payments: AbstractStripePayment[] = [];
	payments.push(new StripeCardPayment(stripe, elements));

	await Promise.all(payments.map(async p => p.init()));

	// UI for adding new payment method for WC Subscriptions.
	const saveToAccountCheckbox = $qs('div.payment_method_peachpay_stripe_card p.woocommerce-SavedPaymentMethods-saveNew');
	if (saveToAccountCheckbox) {
		saveToAccountCheckbox.classList.add('hide');
	}

	const paymentMethodOptions = $qs<HTMLInputElement>('div.payment_method_peachpay_stripe_card ul.woocommerce-SavedPaymentMethods');
	const stripeCardElement = $qs('div.payment_method_peachpay_stripe_card div.woocommerce-SavedPaymentMethods-saveNew');

	if (paymentMethodOptions && stripeCardElement) {
		if (!$qs<HTMLInputElement>('div.payment_method_peachpay_stripe_card input#wc-peachpay_stripe_card-payment-token-new')?.checked) {
			stripeCardElement.classList.add('hide');
		}

		paymentMethodOptions.addEventListener('change', event => {
			if ((event.target as HTMLInputElement).id === 'wc-peachpay_stripe_card-payment-token-new') {
				stripeCardElement.classList.remove('hide');
			} else {
				stripeCardElement.classList.add('hide');
			}
		});
	}

	onCheckoutSubmitManual(
		$addPaymentMethodForm,
		payments.map(v => v.gatewayId()),
		async gatewayId => {
			const payment = payments.find(v => v.gatewayId() === gatewayId);
			if (!payment) {
				return false;
			}

			try {
				if (!tokenizedMethodSelected(gatewayId)) {
					const [paymentId, update] = await payment.setupToken();
					if (!paymentId && update?.note) {
						payment.displayPaymentError(update.note);
					}

					if (!paymentId) {
						return false;
					}

					insertTokenFields($addPaymentMethodForm, paymentId);

					return true;
				}

				return true;
			} catch (error) {
				payment.displayPaymentError((error as Error).message);

				unblockCheckout($addPaymentMethodForm);
				return false;
			}
		});
}

export {initAddPaymentMethodPage};
